import { render, staticRenderFns } from "./txTrend.vue?vue&type=template&id=7d4fb07c&scoped=true&"
import script from "./txTrend.vue?vue&type=script&lang=js&"
export * from "./txTrend.vue?vue&type=script&lang=js&"
import style0 from "./txTrend.vue?vue&type=style&index=0&id=7d4fb07c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4fb07c",
  null
  
)

export default component.exports